import Dropdown from "bootstrap/js/dist/dropdown";
import Tab from "bootstrap/js/dist/tab";
import Collapse from "bootstrap/js/dist/collapse";

(function ($) {
  $(function () {
    function siteHeader() {
      const linksWithDropdown = document.querySelectorAll(
        ".mobile-menu li.menu-item-has-children"
      );
      const arrowDown = `<svg xmlns="http://www.w3.org/2000/svg" width="16.715" height="9.065" viewBox="0 0 16.715 9.065"><path d="M12,26l8-8,8,8" transform="translate(28.361 26.358) rotate(180)" fill="none" stroke="#000" stroke-width="1"/></svg>`;
      const plusIcon = document.createElement("button");
      {
        linksWithDropdown.forEach((link) => {
          const linkItem = link.querySelector("a");
          $(linkItem).append(
            `<button href="#" class="dropdown_arrow" aria-label="A button that opens the dropdown menu">${arrowDown}</button>`
          );
        });
      }
      const menuDropdownbtn = document.querySelectorAll(".dropdown_arrow");

      menuDropdownbtn.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          const targetListItem = e.currentTarget.closest(
            ".menu-item-has-children"
          );
          const targetList = targetListItem.querySelector(".dropdown-menu");

          if (!targetListItem.classList.contains("toggled")) {
            targetListItem.classList.add("toggled");
          } else {
            targetListItem.classList.remove("toggled");
          }
        });
      });
    }
    siteHeader();

    $(".hamburger").on("click", function () {
      $(this).toggleClass("is-active");
      $(".mobile-menu").slideToggle();
    });

    $(".faqs__item-title").on("click", function () {
      $(this).toggleClass("toggled");
      $(this).next(".faqs__item-content").slideToggle();
    });

    $(".block-exhibit").each(function() {

      const $el = $(this);
      const $slides = $el.find(".exhibit__images");
      // const $nav = $el.find(".exhibit__info-author-items");

      $slides.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        adaptiveHeight: true
      });

      // $nav.slick({
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   arrows: false,
      //   dots: false,
      //   adaptiveHeight: true,
      //   asNavFor: $slides,
      // });

    });

    $(".testimonials__items").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 8000,
      prevArrow: $(".testimonials__pagination .prev"),
      nextArrow: $(".testimonials__pagination .next"),
    });

    // const $items = $(".featured-pages__info-item");

    // if ($items.length) {
    //   $(window).on("scroll", function () {
    //     const scrollTop = $(window).scrollTop();

    //     $items.each(function (index) {
    //       const offset = scrollTop * -0.1; // Moves up as user scrolls down
    //       $(this).css("transform", "translateY(" + offset + "px)");
    //     });
    //   });
    // }

    $('.block-text-images').each(function() {
      var $block = $(this);
      var $items = $block.find('.text-images__images-item');
      var is_visible = false;

      // Direction each image should move (towards centre)
      var directions = {
        'one': { x: 15, y: 20 },    // top-left, moves right and down
        'two': { x: -20, y: 15 },   // top-right, moves left and down
        'three': { x: 15, y: -20 }, // bottom-left, moves right and up
        'four': { x: -15, y: -15 }  // bottom-right, moves left and up
      };
      var intensity = 5;

      var observer = new IntersectionObserver(function(entries) {
        is_visible = entries[0].isIntersecting;
      }, { threshold: 0 });

      observer.observe($block[0]);

      $(window).on('scroll', function() {
        if (!is_visible) return;

        var rect = $block[0].getBoundingClientRect();
        var window_height = window.innerHeight;

        // Progress: 0 when entering bottom, 1 when exiting top
        var progress = 1 - (rect.bottom / (window_height + rect.height));
        progress = Math.max(0, Math.min(1, progress));

        $items.each(function() {
          var $item = $(this);
          var dir = null;

          // Match class to direction
          for (var key in directions) {
            if ($item.hasClass(key)) {
              dir = directions[key];
              break;
            }
          }

          if (dir) {
            var x = dir.x * progress * intensity;
            var y = dir.y * progress * intensity;
            $item.css('transform', 'translate(' + x + 'px, ' + y + 'px)');
          }
        });
      });
    });

    $(".team__item-info-link").on("click", function (e) {
      e.preventDefault();
      const modalId = $(this).data("modal-id");
      $("#" + modalId).fadeIn();
    });

    $(".team__popup-play").on("click", function (e) {
      e.preventDefault();
      const $container = $(this).closest(".team__popup-image-inner");
      const videoUrl = $(this).data("video-url");
      const $iframe = $('<iframe src="' + videoUrl + '?autoplay=1&hd=1&controls=0" style="width: 100%; height: 100%; top: 50%; left: 50%; transform: translate(-50%, -50%); position: absolute;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>');
      $container.find("img, .team__popup-play").hide();
      $container.append($iframe);
    });

    $(".team__popup-close a").on("click", function (e) {
      e.preventDefault();
      const $popup = $(this).closest(".team__popup");
      const $container = $popup.find(".team__popup-image-inner");
      $container.find("iframe").remove();
      $container.find("img, .team__popup-play").show();
      $popup.fadeOut();
    });

    var $image = $(".featured-pages__image");

    if ($image.length) {
      var currentTranslate = 0;
      var scrollMultiplier = 0.5;
      var lastScrollTop = $(window).scrollTop();

      function startScrollEffect() {
        $(window).on("scroll.featuredPagesImage", function () {
          var scrollTop = $(window).scrollTop();
          var scrollDelta = scrollTop - lastScrollTop;

          currentTranslate -= scrollDelta * scrollMultiplier;

          var maxTranslate = 0;
          var minTranslate = -($image.outerHeight() / 2);
          currentTranslate = Math.max(
            minTranslate,
            Math.min(maxTranslate, currentTranslate)
          );

          $image.css("transform", "translateY(" + currentTranslate + "px)");
          lastScrollTop = scrollTop;
        });
      }

      // Watch for .aos-animate on the image element
      var checkAOS = setInterval(function () {
        if ($image.hasClass("aos-animate")) {
          clearInterval(checkAOS);
          startScrollEffect();
        }
      }, 100);
    }

    AOS.init();
  });
})(window.jQuery);
